import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "ai-gradient-button__copy" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["ai-gradient-button", `ai-gradient-button--${_ctx.state}`]),
    disabled: _ctx.loading,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    (_ctx.rippleKey)
      ? (_openBlock(), _createElementBlock("span", {
          key: _ctx.rippleKey,
          class: "ai-gradient-button__ripple"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass(["ai-gradient-button__spinner", { 'is-static': !_ctx.loading }])
    }, null, 2),
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.label), 1),
      _createElementVNode("small", null, _toDisplayString(_ctx.hint), 1)
    ])
  ], 10, _hoisted_1))
}